import { create } from "zustand";

import axios from "../helper/axios";

const useSuperUserInfoStore = create((set) => ({
    superUserInfo: null,
    superUserAnalytics: null,
    superAdminInfo:null,
    superUserUpdateflag:true,
    userVerificationFile: null,
    superUserCompanyAnalytics:null,

    resetSuperUserUpdateFlag: () => {
        set({ superUserUpdateflag: false });
    },
    getSuperUserCompanyAnalytics: async (duration,company_id) => {
        try {
           const userData = JSON.parse(localStorage.getItem("userDetails"));
           const response = await axios.get(`/getSuperuserCompanyAnalytics/${userData.qhoid}/${userData.qhuid}/${duration}/${company_id}`);
            //console.log(response.data.name); 
            //console.log(response.data.data);
            set({ superUserCompanyAnalytics: response.data.data});
        } catch (err) {
            console.error(err);
        }
    },     
    getSuperUserAnalytics: async (duration) => {
        try {
           const userData = JSON.parse(localStorage.getItem("userDetails"));
           const response = await axios.get(`/getSuperuserAnalytics/${userData.qhoid}/${userData.qhuid}/${duration}`);
            //console.log(response.data.name); 
            //console.log(response.data.data);
            set({ superUserAnalytics: response.data.data});
        } catch (err) {
            console.error(err);
        }
    },     
    getSuperUserInfo: async (duration) => {
        try {
           const userData = JSON.parse(localStorage.getItem("userDetails"));
           const response = await axios.get(`/getSuperuserInfo/${userData.qhoid}/${userData.qhuid}/${duration}`);
            //console.log(response.data.name); 
            //console.log(response.data.data);
            set({ superUserInfo: response.data.data});
        } catch (err) {
            console.error(err);
        }
    }, 
 
    updateSuperUserSubscriptionStatus: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            //console.log(body);
            const response = await axios.post(
                `/candidatestatus/${userData.qhoid}/${userData.qhuid}/jds/${body.qhjid}`,
                body.jasonValues
            );
            //console.log(response.data);
        } catch (err) {
            console.error(err);
        }
    },   
    updateSuperUserOfferPlans: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            //console.log(body);
            const response = await axios.post(
                `/updateSuperuserQhrPlan/${userData.qhoid}/${userData.qhuid}`,
                body.jasonValues
            );
            //console.log(response.data.name); 
            //console.log(response.data.status);
        } catch (err) {
            console.error(err);
        }
    }, 
    updateSuperUserDocumentStatus: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            //console.log(body);
            const response = await axios.post(
                `/updateSuperuserDocumentStatus/${userData.qhoid}/${userData.qhuid}`,
                body.jasonValues
            );
            ///console.log(response.data.name); 
            //console.log(response.data.status);
            set({ superUserUpdateflag: true});
        } catch (err) {
            console.error(err);
        }
    },  
    updateSuperUserFreeStatus: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            //console.log(body);
            const response = await axios.post(
                `/updateSuperuserFreeStatus/${userData.qhoid}/${userData.qhuid}`,
                body.jasonValues
            );
            ///console.log(response.data.name); 
            //console.log(response.data.status);
            set({ superUserUpdateflag: true});
        } catch (err) {
            console.error(err);
        }
    },
    updateSuperUserSubsStatus: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            //console.log(body);
            const response = await axios.post(
                `/updateSuperuserSubsStatus/${userData.qhoid}/${userData.qhuid}`,
                body.jasonValues
            );
            ///console.log(response.data.name); 
            //console.log(response.data.status);
            set({ superUserUpdateflag: true});
        } catch (err) {
            console.error(err);
        }
    }, 
    
    getSuperAdminInfo: async (duration) => {
        try {
           const userData = JSON.parse(localStorage.getItem("userDetails"));
           const response = await axios.get(`/getSuperadminInfo/${userData.qhoid}/${userData.qhuid}/${duration}`);
            //console.log(response.data.name); 
            //console.log(response.data.data);
            set({ superAdminInfo: response.data.data});
        } catch (err) {
            console.error(err);
        }
    },
    fetchUserDoc: async (owner_id,user_id) => {
        try {
            const response = await axios.get(`/getCompanyDocuments/${owner_id}/${user_id}`, {
                responseType: 'blob'
            });

            const blob = new Blob([response.data], { type: response.headers['content-type'] });


            set({ userVerificationFile: response.data });

            return response.data;
        } catch (err) {
            console.error(err);
            throw err;
        }
    },
}));

export default useSuperUserInfoStore;
